import * as Login from './mixpanel-login';

export default {
  Login,
};
